import { render } from "./createAccount.vue?vue&type=template&id=d6a5e418&scoped=true"
import script from "./createAccount.vue?vue&type=script&lang=js"
export * from "./createAccount.vue?vue&type=script&lang=js"

import "./createAccount.vue?vue&type=style&index=0&id=d6a5e418&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d6a5e418"]])

export default __exports__